module.exports = __webpack_public_path__ + "51fb4e65d80d01d3afb6a012f2f3382a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_7_teaser_image.jpg
// module id = 553
// module chunks = 0